(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesignMode = window.Shopify && window.Shopify.designMode;

  function showAllReveals() {
    document.querySelectorAll('[data-reveal], [data-reveal-child], .collection-header, .product-page__media, .product-page__info').forEach((el) => {
      el.classList.remove('reveal-pending');
      el.classList.add('is-visible');
    });
    document.querySelector('[data-hero]')?.classList.add('is-loaded');
  }

  function revealIfInView(el) {
    const rect = el.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;
    if (inView) {
      el.classList.remove('reveal-pending');
      el.classList.add('is-visible');
      return true;
    }
    return false;
  }

  function initMotion() {
    document.documentElement.classList.add('motion-ready');

    if (reducedMotion || isDesignMode) {
      showAllReveals();
      return;
    }

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('reveal-pending');
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.01, rootMargin: '0px 0px 80px 0px' }
    );

    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el) => {
      el.classList.add('reveal-pending');
      if (!revealIfInView(el)) revealObserver.observe(el);
    });

    document.querySelectorAll('[data-reveal-stagger]').forEach((parent) => {
      parent.querySelectorAll('[data-reveal-child]:not(.is-visible)').forEach((child, i) => {
        child.classList.add('reveal-pending');
        child.style.transitionDelay = `${i * 0.08}s`;
        if (!revealIfInView(child)) revealObserver.observe(child);
      });
    });

    document.querySelectorAll('.collection-header, .product-page__media, .product-page__info').forEach((el) => {
      if (el.classList.contains('is-visible')) return;
      el.classList.add('reveal-pending');
      if (!revealIfInView(el)) revealObserver.observe(el);
    });

    const hero = document.querySelector('[data-hero]');
    if (hero && !hero.classList.contains('is-loaded')) {
      requestAnimationFrame(() => {
        hero.classList.add('is-loaded');
        initHeroCounters(hero);
      });
    }

    initTilt();
    initHeaderScroll();
    initButtonShine();

    /* Failsafe — never leave sections hidden */
    setTimeout(showAllReveals, 2500);
  }

  function initHeroCounters(hero) {
    if (reducedMotion || isDesignMode) return;

    hero.querySelectorAll('.hero__stat').forEach((stat, i) => {
      setTimeout(() => {
        const strong = stat.querySelector('strong');
        if (!strong || stat.dataset.counted) return;

        const countAttr = strong.dataset.count;
        if (countAttr) {
          const end = parseInt(countAttr, 10);
          const suffix = strong.textContent.replace(/[\d.]+/, '');
          const duration = 1000;
          const startTime = performance.now();

          const tick = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - (1 - progress) ** 3;
            strong.textContent = Math.round(end * eased) + suffix;
            if (progress < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }

        stat.classList.add('is-counted');
        stat.dataset.counted = 'true';
      }, 700 + i * 120);
    });
  }

  function initTilt() {
    if (reducedMotion || isDesignMode) return;

    document.querySelectorAll('[data-tilt]:not([data-tilt-bound]):not(.product-card)').forEach((el) => {
      if (el.closest('.product-card')) return;
      el.dataset.tiltBound = 'true';
      const inner =
        el.querySelector('.tilt-card__inner') ||
        el.querySelector('.hero__image-wrap') ||
        el.querySelector('.product-showcase__image-inner') ||
        el;
      const maxTilt = parseFloat(el.dataset.tiltMax) || 12;

      el.addEventListener('mousemove', (e) => {
        const rect = el.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        inner.style.transform = `rotateX(${-y * maxTilt}deg) rotateY(${x * maxTilt}deg) scale3d(1.02, 1.02, 1.02)`;
      });

      el.addEventListener('mouseleave', () => {
        inner.style.transform = '';
      });
    });
  }

  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header || header.dataset.scrollBound) return;
    header.dataset.scrollBound = 'true';

    const onHeaderScroll = () => {
      header.classList.toggle('site-header--scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  function initButtonShine() {
    document.querySelectorAll('.btn:not([data-shine-bound]):not(.product-card__btn)').forEach((btn) => {
      if (btn.closest('.product-card')) return;
      btn.dataset.shineBound = 'true';
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        btn.style.setProperty('--btn-x', `${((e.clientX - rect.left) / rect.width) * 100}%`);
        btn.style.setProperty('--btn-y', `${((e.clientY - rect.top) / rect.height) * 100}%`);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion);
  } else {
    initMotion();
  }

  document.addEventListener('shopify:section:load', initMotion);
})();
